import { Link as InnerLink } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '@xing-com/button';

import { ArrowIcon as InnerArrowIcon } from '../arrow-icon';

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 100%;
  margin: var(--spaceS) 0 var(--spaceL);
  height: var(--spaceL);
`;

export const HomeButton = styled(Button)`
  margin: 0;
  padding: 0;
  min-width: 0;
  height: auto;
  margin-top: -2px;
`;

export const Breadcrumb = styled.div`
  display: flex;
  font-size: var(--spaceM);
  align-items: center;
`;

export const ArrowIcon = styled(InnerArrowIcon)`
  margin: 0 var(--spaceXS);
  display: block;
`;

export const Last = styled.span`
  color: var(--xdlColorText);
  line-height: var(--spaceL);
  font-weight: bold;
`;

export const Link = styled(InnerLink)`
  color: var(--xdlColorText);
  line-height: var(--spaceL);
`;
